interface NavAttributes {
  [propName: string]: any;
}
interface NavWrapper {
  attributes: NavAttributes;
  element: string;
}
interface NavBadge {
  text: string;
  variant: string;
}
interface NavLabel {
  class?: string;
  variant: string;
}

export interface NavData {
  name?: string;
  url?: string;
  icon?: string;
  badge?: NavBadge;
  title?: boolean;
  children?: NavData[];
  variant?: string;
  attributes?: NavAttributes;
  divider?: boolean;
  class?: string;
  label?: NavLabel;
  wrapper?: NavWrapper;
  visible?: boolean;
}

export const navItems: NavData[] = [
  {
    name: 'Dashboard',
    url: '/dashboard',
    icon: 'icon-speedometer',
    badge: {
      variant: 'info',
      text: 'NEW'
    },
    visible: true
  },
  {
    name: 'Partners',
    url: '/base/partners',
    icon: 'icon-puzzle',
    visible: true
  },
  {
    name: 'Leads',
    url: '/base/leads',
    icon: 'icon-puzzle',
    visible: true
  },
  {
    name: 'Boxes',
    url: '/base/boxes',
    icon: 'icon-puzzle',
    visible: true
  },
  {
    name: 'Searchusers',
    url: '/base/searchusers',
    icon: 'icon-puzzle',
    visible: true
  },

  // {
  //   name: 'Modules',
  //   url: '/base',
  //   icon: 'icon-puzzle',
  //   children: [
  //     {
  //       name: 'Forms',
  //       url: '/base/forms',
  //       icon: 'icon-puzzle'
  //     },
  //     {
  //       name: 'Tables',
  //       url: '/base/tables',
  //       icon: 'icon-puzzle'
  //     }
  //   ]
  // },

  /*{
    name: 'Assign Leads',
    url: '/base/assignleads',
    icon: 'icon-puzzle',
    visible: false
  },

  {
    name: 'Assign Boxes',
    url: '/base/assignboxes',
    icon: 'icon-puzzle',
    visible: true
  },*/

  {
    name: 'Insert Adminer Leads',
    url: '/base/insertadminerleads',
    icon: 'icon-puzzle',
    visible: true
  },
  {
    name: 'Activations',
    url: '/base/activation',
    icon: 'icon-puzzle',
    visible: true
  },
  {
    name: 'Upgrade Retail Box',
    url: '/base/upgraderetailbox',
    icon: 'icon-puzzle',
    visible: true
  },
  {
    name: 'Change Partner',
    url: '/base/changepartner',
    icon: 'icon-puzzle',
    visible: true
  },
  {
    name: 'Distributor Activations',
    url: '/base/distributoractivations',
    icon: 'icon-puzzle',
    visible: true
  },
  {
    name: 'Check Plan Price',
    url: '/base/checkplanprice',
    icon: 'icon-puzzle',
    visible: true
  },
  {
    name: 'Leads with Phone No./Email Id',
    url: '/base/leadswithutm',
    icon: 'icon-puzzle',
    visible: true
  },
  {
    name: 'Request License',
    url: '/base/requestlicense',
    icon: 'icon-puzzle',
    visible: true
  }
];
